module.exports = __webpack_public_path__ + "img/winner3.4cfc68be.png";